var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"donation-modal"},[_c('div',{ref:"homeDonationForm",staticClass:"donation-modal-inner custom-scroll"},[_c('Donation')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }